import { Container } from 'reactstrap';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Helmet } from "react-helmet";

// Local Deps
// import messages from '../../config/messages';
import UserForm from '../forms/UserForm';
import AddUserHOC from './AddUserHOC';
import './AddUser.scss';

class AddUser extends PureComponent {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onChangeRole: PropTypes.func.isRequired,
    onChangeField: PropTypes.func.isRequired,
    returnToAccountAdmin: PropTypes.func.isRequired,
    initialValues: PropTypes.shape({
      fullName: PropTypes.string,
      email: PropTypes.string,
      phoneNumber: PropTypes.string,
      faxNumber: PropTypes.string,
      iconStatus: PropTypes.string,
      role: PropTypes.string,
    }).isRequired,
    auth: PropTypes.shape({
      jwtToken: PropTypes.string,
      expiration: PropTypes.number,
      organizationId: PropTypes.string,
    }).isRequired,
    iconStatusIsHidden: PropTypes.bool.isRequired,
    alertType: PropTypes.string.isRequired,
    alertMessage: PropTypes.string.isRequired,
  };

  render() {
    const {
      onSubmit,
      onChangeRole,
      onChangeField,
      initialValues,
      auth,
      iconStatusIsHidden,
      alertType,
      alertMessage,
      returnToAccountAdmin,
    } = this.props;

    console.log("initialValues")
    console.log(initialValues)

    return (
      <div className="nf-add-user">
        <Helmet>
          <meta charSet="utf-8" />
          <title>NFFS ICON - Add User Page</title>
        </Helmet>
        <div className="add-user-main-container">
          <div className="add-user-header">
            <h1>User Management</h1>
            <p>Add a new user to your organization and assign permissions.</p>
          </div>
          <Container>
            <UserForm
              {...{
                initialValues,
                onChangeRole,
                onChangeField,
                iconStatusIsHidden,
                onSubmit,
                alertType,
                alertMessage,
                auth,
                onCancelUserForm: returnToAccountAdmin,
              }}
            />
          </Container>
        </div>
      </div>
    );
  }
}

export default AddUserHOC(AddUser);



// WEBPACK FOOTER //
// ./src/components/AddUser/AddUser.jsx